module.exports = __webpack_public_path__ + "static/img/wechat.5fafed05.png";